<ng-container *ngIf="isVisible">
  <div class="modal-window__header">
    <div class="modal-window__title">{{ user?.firstName }} {{ user?.lastName }}</div>
    <div class="c-user-menu__email">{{ user?.email }}</div>
    <mat-divider class="modal-title__divider"></mat-divider>
    <a (click)="modalService.close()">
      <i class="c-icon c-icon--close-dark"></i>
    </a>
  </div>
  <ul class="flex o-list user-settings__list">
    <li>
      <region-select></region-select>
    </li>
    <li>
      <language-select></language-select>
    </li>
    <li>
      <div class="c-user-menu__item c-user-menu__item--company">
        <mat-label
          class="c-user-menu__label"
          for="company">
          {{ localizationConstants.USER_SETTINGS_COMPANY | translate }}
        </mat-label>

        <input
          [readonly]="user?.isUserGroupProfile"
          type="text"
          #companySelectInput
          name="company"
          id="company"
          [placeholder]="
            localizationConstants.COMPANY_SELECT_MIN_LENGTH
              | translate: { value: companyService.minLengthTerm }
          "
          matInput
          #trigger="matAutocompleteTrigger"
          (click)="openPanel(trigger)"
          [matAutocomplete]="auto"
          [value]="auto.isOpen ? '' : companyService.selectedCompany?.fullName || ''"
          (input)="onCompanySelectInput($event)"
          class="c-select c-select--lg c-user-menu__input"
          [class.input-invalid]="!companyService.selectedCompany"
          [class.loading]="companyService.companiesLoading" />
        <app-loading-icon
          *ngIf="companyService.companiesLoading"
          class="u-color--light c-autocomplete__spinner">
        </app-loading-icon>
        <mat-autocomplete
          #auto="matAutocomplete"
          class="c-user-menu__autocomplete c-autocomplete c-autocomplete--lg"
          [displayWith]="companyAutocompleteDisplayFn"
          [autoActiveFirstOption]="false"
          [autoSelectActiveOption]="false"
          (optionSelected)="companyService.onSelectionChange($event?.option?.value)">
          <mat-option
            *ngFor="let company of companyService.companies$ | async"
            [value]="company">
            {{
              company
                ? company.fullName + ", " + company.name
                : (localizationConstants.COMPANY_SELECT_MIN_LENGTH
                  | translate: { value: companyService.minLengthTerm })
            }}
          </mat-option>
        </mat-autocomplete>
      </div>
    </li>
    <li *ngIf="companyService.selectedCompany">
      <div class="c-user-menu__item c-user-menu__item--dept">
        <mat-label
          class="c-user-menu__label"
          for="dept">
          {{ localizationConstants.USER_SETTINGS_DEPARTMENTS | translate }}
        </mat-label>
        <mat-select
          #deptSelect
          name="dept"
          [placeholder]="localizationConstants.DEPARTMENT_SELECT_ALL | translate"
          [ngModel]="companyService.selectedCompany.department"
          (ngModelChange)="onDepartmentSelectionChange($event)"
          id="dept"
          class="c-user-menu__select c-select c-select--lg">
          <mat-option
            *ngFor="let department of companyService.selectedCompany?.departments"
            [value]="department">
            <ng-container [ngSwitch]="department.departmentFilterType">
              <ng-container *ngSwitchCase="departmentFilterType.Department">
                {{
                  department.fullName
                    ? department.fullName + ", " + department.name
                    : department.name
                }}
              </ng-container>
              <ng-container *ngSwitchCase="departmentFilterType.NoDepartment">
                {{ localizationConstants.DEPARTMENT_NO_DEPARTMENT_SELECTION | translate }}
              </ng-container>
              <ng-container *ngSwitchCase="departmentFilterType.AllDepartments">
                {{ localizationConstants.DEPARTMENT_SELECT_ALL | translate }}
              </ng-container>
            </ng-container>
          </mat-option>
        </mat-select>
      </div>
    </li>
    <li>
      <a
        *ngIf="companyService.selectedCompany && user?.allowReminders"
        class="button button-primary button-block"
        (click)="navigate(routeNameConstants.REMINDERS)"
        >{{ localizationConstants.HEADER_REMINDERS | translate }}</a
      >
    </li>
    <li class="o-list__item">
      <a
        *ngIf="user?.isAdminGroupProfile"
        id="admin-link"
        class="button button-primary button-block"
        (click)="navigate(routeNameConstants.ADMIN)"
        >{{ localizationConstants.HEADER_ADMIN | translate }}</a
      >
    </li>
    <li>
      <a
        type="button"
        (click)="logout()"
        class="button button-secondary button-block"
        >{{ localizationConstants.USER_SETTINGS_BUTTON_LOGOUT | translate }}</a
      >
    </li>
  </ul>
</ng-container>
